import { render, staticRenderFns } from "./EditTimetableRecord.vue?vue&type=template&id=84ac30b4&"
import script from "./EditTimetableRecord.vue?vue&type=script&lang=js&"
export * from "./EditTimetableRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports